
import people2 from '../../assest/ahbaab/Cleanroom Products.jpg'
import people3 from '../../assest/ahbaab/lab-5.jpg'
import people4 from '../../assest/ahbaab/home-banner-2.jpg'
import people5 from '../../assest/ahbaab/Gloves.jpg'
import people6 from '../../assest/ahbaab/cleanroo-factory.jpg'



const TopBannersData = [
    
    {
        id: 1,
        src: people2,
    },
    {
        id: 2,
        src: people3,
    }, 
    {
        id: 3,
        src: people4,
    }, 
    {
        id: 4,
        src: people5,
    }, 
    {
        id: 5,
        src: people6,
    }, 
    
   
];
export default TopBannersData;
